import React from "react";
import ButtonMUI from "@material-ui/core/Button";
import makeStyles from "@material-ui/styles/makeStyles";
import PulseLoader from "react-spinners/PulseLoader";

const useStyles = makeStyles(theme => ({
  button: {
    fontSize: "1rem",
    fontWeight: theme.fontWeightMedium,
    padding: "16px 20px",
    marginRight: theme.spacing(1),
    lineHeight: 1,
    textTransform: "inherit",
    "&:focus": {
      outline: "none",
    },
    "&.MuiButton-sizeSmall": {
      fontSize: "0.875rem",
      padding: "11px 20px",
    },
    "&.Mui-disabled": {
      background: theme.palette.grey[300],
      color: theme.palette.grey[500],
    },
    "&.MuiButton-contained": {
      "&.MuiButton-containedSizeSmall": {
        padding: "11px 20px",
      },
      "&.MuiButton-containedPrimary": {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: theme.palette.primary.hover,
        },
        "&:focus": {
          backgroundColor: theme.palette.primary.focus,
        },
        "&:active": {
          backgroundColor: theme.palette.primary.active,
        },
      },
      "&.MuiButton-containedSecondary": {
        backgroundColor: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: theme.palette.secondary.hover,
        },
        "&:focus": {
          backgroundColor: theme.palette.secondary.focus,
        },
        "&:active": {
          backgroundColor: theme.palette.secondary.active,
        },
      },
      "&.Mui-disabled": {
        background: theme.palette.grey[300],
        color: theme.palette.grey[500],
      },
    },
    "&.MuiButton-outlined": {
      borderWidth: "2px",
      padding: "14px 20px",
      "&.MuiButton-outlinedSizeSmall": {
        padding: "9px 20px",
      },
      "&.MuiButton-outlinedPrimary": {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: theme.palette.primary.hover,
          borderColor: theme.palette.primary.hover,
          color: "white",
        },
        "&:focus": {
          backgroundColor: theme.palette.primary.focus,
          borderColor: theme.palette.primary.focus,
          color: "white",
        },
        "&:active": {
          backgroundColor: theme.palette.primary.active,
          borderColor: theme.palette.primary.active,
          color: "white",
        },
      },
      "&.MuiButton-outlinedSecondary": {
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: theme.palette.secondary.hover,
          borderColor: theme.palette.secondary.hover,
          color: "white",
        },
        "&:focus": {
          backgroundColor: theme.palette.secondary.focus,
          borderColor: theme.palette.secondary.focus,
          color: "white",
        },
        "&:active": {
          backgroundColor: theme.palette.secondary.active,
          borderColor: theme.palette.secondary.active,
          color: "white",
        },
      },
      "&.Mui-disabled": {
        background: theme.palette.grey[300],
        color: theme.palette.grey[500],
        borderColor: theme.palette.grey[300],
      },
    },
  },
}));

function Button(props) {
  const classes = useStyles(props);
  return (
    <ButtonMUI
      disableRipple
      disabled={props.isloading === 1 || props.isdisabled === 1 ? true : false}
      className={classes.button}
      startIcon={
        props.isloading === 1 ? <PulseLoader size={10} color="#9e9e9e" /> : ""
      }
      disableElevation
      {...props}
    />
  );
}

export default Button;
